import React from 'react';
import { Step0Props } from './types';
import { ImageIcon, EditIcon } from '../create-contract/icons';
import { languages } from '../../../constant/header.constant';

const Step0LogoProfile: React.FC<Step0Props> = (props) => {
    const { t, logoUrl, lang, onLangChange, onNavigateToProfile } = props;

    return (
        <div className="cc-card">
            <div className="cc-card-header">
                <span className="cc-card-icon"><ImageIcon /></span>
                <div className="cc-card-heading-text">
                    <h3 className="cc-card-title">{t('CO_LOGO_CARD_TITLE')}</h3>
                    <p className="cc-card-subtitle">{t('CO_LOGO_CARD_SUBTITLE')}</p>
                </div>
            </div>
            <div className="cc-card-body">

                {/* Logo row */}
                <div className="cc-logo-row">
                    <div className="cc-logo-zone">
                        {logoUrl
                            ? <img src={logoUrl} alt="company logo" className="cc-logo-img" />
                            : <img src="/assets/logo_large.png" alt="default logo" className="cc-logo-img" />
                        }
                    </div>
                    <div className="cc-logo-info">
                        <button
                            className="cc-btn-tertiary"
                            type="button"
                            onClick={onNavigateToProfile}
                        >
                            <EditIcon /> {t('CO_LOGO_CHANGE_IN_SETTINGS')}
                        </button>
                        <p className="cc-body-text">{t('CO_LOGO_SETTINGS_NOTE')}</p>
                    </div>
                </div>

                <div className="cc-separator" style={{ marginTop: 24 }} />

                {/* Invozio Information */}
                <h3 className="cc-card-title" style={{ marginBottom: 16 }}>{t('CO_INVOZIO_INFO_TITLE')}</h3>
                <div className="cc-info-box">
                    <p className="cc-info-text">{t('CO_INVOZIO_INFO_COMPANY')}</p>
                    <p className="cc-info-text">{t('CO_INVOZIO_INFO_REG')}</p>
                    <p className="cc-info-text cc-info-text--italic">{t('CO_INVOZIO_INFO_REF')}</p>
                </div>

                <div className="cc-field" style={{ maxWidth: 320, marginTop: 16 }}>
                    <label className="cc-label">{t('CO_PREFERRED_LANGUAGE_LABEL')}</label>
                    <select
                        className="cc-input cc-select"
                        value={lang}
                        onChange={e => onLangChange(e.target.value)}
                    >
                        {languages.map(language => (
                            <option key={language.code} value={language.code}>
                                {t(language.label)}
                            </option>
                        ))}
                    </select>
                    <p className="cc-hint-text">{t('CO_PREFERRED_LANGUAGE_HINT')}</p>
                </div>

            </div>
        </div>
    );
};

export default Step0LogoProfile;
